/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface V3ApplicationDealerportalGet$Params {
  appId?: string;
}

export function v3ApplicationDealerportalGet(http: HttpClient, rootUrl: string, params?: V3ApplicationDealerportalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationDealerportalGet.PATH, 'get');
  if (params) {
    rb.query('appId', params.appId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

v3ApplicationDealerportalGet.PATH = '/v3/application/dealerportal';
